import { render } from "./ProductFeedBack.vue?vue&type=template&id=6a09b016&scoped=true"
import script from "./ProductFeedBack.vue?vue&type=script&lang=js"
export * from "./ProductFeedBack.vue?vue&type=script&lang=js"

import "./ProductFeedBack.vue?vue&type=style&index=0&id=6a09b016&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a09b016"]])

export default __exports__